import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HospbillComponent } from './hospbill/hospbill.component';

const routes: Routes = [
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
